import { mapValues } from 'lodash';

export const getInitialErrors = (initialUser, taxClassification) => {
  const result = mapValues(initialUser, value => !!!value);

  if (taxClassification === '1099') {
    result.date_of_birth = false;
  }

  return result;
};
